module.exports = __webpack_public_path__ + "static/media/str-chat__reaction-list-sprite@3x.151510d6.png";